// extracted by mini-css-extract-plugin
export var desktopNavItem = "NavButton-module--desktopNavItem--0909e";
export var drawer = "NavButton-module--drawer--1c6cd";
export var hidden = "NavButton-module--hidden--7d2d1";
export var imageContainer = "NavButton-module--imageContainer--34b4e";
export var isOpen = "NavButton-module--isOpen--6d20b";
export var label = "NavButton-module--label--f568a";
export var mobileNavItem = "NavButton-module--mobileNavItem--19c51";
export var navButton = "NavButton-module--navButton--bd994";
export var open = "NavButton-module--open--f5d78";
export var previouslyOpen = "NavButton-module--previouslyOpen--7a0cd";
export var shouldTransition = "NavButton-module--shouldTransition--d3f63";